import * as $            from 'jquery';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import {ServiceTransferDataFromPlannerToCart} from 'Components/Planner/ServiceTransferDataFromPlannerToCart';
import {ServiceSavePlannerProject} from 'Components/Planner/ServiceSavePlannerProject';
import {ServiceOpenPlannerProject} from 'Components/Planner/ServiceOpenPlannerProject';

export class Planner {

    public isFullAccessMode : boolean = true;

    /**
     * Inicjalizacja Dekoratora
     */
    public init() {
        if ($(PlannerSelectors.DECORATOR_FULL_ID).length) {
            this.initPlaner()
        }
    }

    /**
     * Inicjalizacja planera 3d
     */
    public initPlaner()
    {
        // @ts-ignore
        RunNetPlusApp(PlannerSelectors.DECORATOR_ID,
            "/dekorator/app/Build/",
            '{ "dbaddr": "' + window.location.origin + '/dekorator/database/" }',
            this.runPlaner);

        this.isFullAccessMode = $(PlannerSelectors.DECORATOR_FULL_ID).data('is-full-access-mode');
    }

    /**
     * Podpięcie pod eventy
     */
    public runPlaner()
    {
        // @ts-ignore
        NetDecor.Shop.SetPricesFileUrl(window.location.origin + '/web/cache/planner-product-prices.json?' + new Date().toISOString().substring(0, 19) );

        // Logowanie
        let plannerContainer = $(PlannerSelectors.DECORATOR_FULL_ID);
        let loginState = {
            "state" : plannerContainer.data('is-user'),
            "name" : plannerContainer.data('user-name')
        }
        if(loginState.state == true){
            // @ts-ignore
            NetDecor.Login.SetLoginState(JSON.stringify(loginState))
        }

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("Login",function(){
            $(PlannerSelectors.TOOGLER).filter(':visible').first().click();
        });

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("Logout",function(){
            let href = $(PlannerSelectors.SIGN_OUT).attr("href");
            $.get(href, function() {
                window.location.reload();
            });
        });

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("SaveProject",function(buffer, png, jsondata, items) {
                let isFullAccessMode = plannerContainer.data('is-full-access-mode');
                // console.log(Planner.isFullAccessMode);
                if(!isFullAccessMode){
                    alert('W tym trybie nie możesz zapisywać projektów planera!');
                    return;
                }
                let service = new ServiceSavePlannerProject();
                service.init(buffer, png, jsondata, items);
            });

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("ShowProjects",function() {
                let service = new ServiceOpenPlannerProject();
                // @ts-ignore
                service.init(NetDecor);
            });

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("AddToBasket", function(basketContent){
            let transfer = new ServiceTransferDataFromPlannerToCart();
            transfer.initTransfer(basketContent);
        });

    }

}import * as $            from 'jquery';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import {ServiceTransferDataFromPlannerToCart} from 'Components/Planner/ServiceTransferDataFromPlannerToCart';
import {ServiceSavePlannerProject} from 'Components/Planner/ServiceSavePlannerProject';
import {ServiceOpenPlannerProject} from 'Components/Planner/ServiceOpenPlannerProject';

export class Planner {

    public isFullAccessMode : boolean = true;

    /**
     * Inicjalizacja Dekoratora
     */
    public init() {
        if ($(PlannerSelectors.DECORATOR_FULL_ID).length) {
            this.initPlaner()
        }
    }

    /**
     * Inicjalizacja planera 3d
     */
    public initPlaner()
    {
        // @ts-ignore
        RunNetPlusApp(PlannerSelectors.DECORATOR_ID,
            "/dekorator/app/Build/",
            '{ "dbaddr": "' + window.location.origin + '/dekorator/database/" }',
            this.runPlaner);

        this.isFullAccessMode = $(PlannerSelectors.DECORATOR_FULL_ID).data('is-full-access-mode');
    }

    /**
     * Podpięcie pod eventy
     */
    public runPlaner()
    {
        // @ts-ignore
        NetDecor.Shop.SetPricesFileUrl(window.location.origin + '/web/cache/planner-product-prices.json?' + new Date().toISOString().substring(0, 19) );

        // Logowanie
        let plannerContainer = $(PlannerSelectors.DECORATOR_FULL_ID);
        let loginState = {
            "state" : plannerContainer.data('is-user'),
            "name" : plannerContainer.data('user-name')
        }
        if(loginState.state == true){
            // @ts-ignore
            NetDecor.Login.SetLoginState(JSON.stringify(loginState))
        }

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("Login",function(){
            $(PlannerSelectors.TOOGLER).filter(':visible').first().click();
        });

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("Logout",function(){
            let href = $(PlannerSelectors.SIGN_OUT).attr("href");
            $.get(href, function() {
                window.location.reload();
            });
        });

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("SaveProject",function(buffer, png, jsondata, items) {
                let isFullAccessMode = plannerContainer.data('is-full-access-mode');
                // console.log(Planner.isFullAccessMode);
                if(!isFullAccessMode){
                    alert('W tym trybie nie możesz zapisywać projektów planera!');
                    return;
                }
                let service = new ServiceSavePlannerProject();
                service.init(buffer, png, jsondata, items);
            });

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("ShowProjects",function() {
                let service = new ServiceOpenPlannerProject();
                // @ts-ignore
                service.init(NetDecor);
            });

        // @ts-ignore
        NetDecor.Events.RegisterEventHandler("AddToBasket", function(basketContent){
            let transfer = new ServiceTransferDataFromPlannerToCart();
            transfer.initTransfer(basketContent);
        });

    }

}